import styles from "./ParentPortalBanner.module.css";
import Image from "next/image";
import { ParentPortalBannerProps } from "./ParentPortalBanner.type";
import Button from "../../components/Button";
import { useSelector } from "react-redux";
import arrowRight2 from "../../assets/icons/arrow-right-01.png";
import Link from "next/link";
import { useState } from "react";
import BookTourPopUp from "../BookTourPopup";
import { useRouter } from "next/router";

const ParentPortalBanner = (props: ParentPortalBannerProps) => {
  const {isParent} = props;
  const banners = props.data;
  const router = useRouter();
  const { slug } = router?.query;
    
const [isShowPopup, setIsShowPopup] = useState(false);

  const { isMobileDevice } = useSelector((state: any) => state.data);  

 const handleCranleighTour = (e: React.MouseEvent) => {
  e.preventDefault(); 
   if(slug == "cranleigh-abu-dhabi") {
    setIsShowPopup(true);
   }
 };

 const validLink = isParent
  ? banners?.hyperlink?.results?.[0]?.hyperlink
  : banners?.hyperlink;

const isValidHyperlink = validLink && validLink !== '#';

  return (
    <>
      {props?.data && (
        <div className={`container page-parentPortal ${isParent && styles.parent_dashboard}`}  data-testid="parent-portal-container">
          <div className={`row ${props?.isCareer && styles.parentCon}`} data-testid="parent-portal-row">
            <div className="col-12 col-md-12" data-testid="parent-portal-column">
              <div className={` ${styles.card}`} data-testid="parent-portal-card">
                <Image
                  src={
                      isMobileDevice
                      ? banners?.mobileimage?.results[0]?.fileUrl
                      : banners?.image?.results[0]?.fileUrl
                  }
                  alt="imgcontainer"
                  width={300}
                  height={584}
                  data-testid="banner-image"
                />
                <div className={` ${styles.overlayText}`} data-testid="overlay-text">
                  <h1 data-testid="banner-title">{banners?.title}</h1>
                  <p
                    className={styles.desc}
                    dangerouslySetInnerHTML={{
                      __html:
                      isParent ? banners?.description : banners?.maintitle?.content?.[0]?.content?.[0]?.text,
                    }}
                    data-testid="banner-description"
                  />

                  <Button
                    href={banners?.hyperlink}
                    className={` ${styles.showMore}`}
                    data-testid="show-more-button"
                    // onClick={(e) => handleCranleighTour(e)}
                  >
                    <>
                      {isValidHyperlink ? (
                        <Link
                          href={validLink}
                          target={
                            isParent
                              ? banners?.hyperlink?.results?.[0]?.externallink === true ? "_blank" : ""
                              : banners?.externallink === true ? "_blank" : ""
                          }
                          className={styles.showMore}
                          data-testid="banner-link"
                        >
                          {isParent
                            ? banners?.hyperlink?.results?.[0]?.name
                            : banners?.subtitle}
                        </Link>
                      ) : (
                        <span
                          onClick={handleCranleighTour}
                          className={styles.showMore}
                          data-testid="banner-link"
                          style={{ cursor: 'pointer' }}
                        >
                          {isParent
                            ? banners?.hyperlink?.results?.[0]?.name
                            : banners?.subtitle}
                        </span>
                      )}

                      <Image
                        src={ banners?.icon?.results?.[0]?.fileUrl || arrowRight2}
                        alt="arrow-right"
                        height={24}
                        width={24}
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        data-testid="arrow-icon"
                      />
                    </>
                  </Button>
                  <BookTourPopUp showPopup={isShowPopup} setShowPopup={setIsShowPopup} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ParentPortalBanner;
